import React, { useContext } from "react";
import Row from "@amzn/meridian/row";
import ControlGroup from "@amzn/meridian/control-group";
import Checkbox from "@amzn/meridian/checkbox";
import RadioButton from "@amzn/meridian/radio-button";
import Column from "@amzn/meridian/column";
import AssociateScanChart from "./AssociateScanChart";
import { AssociateScanContext } from "./context/AssociateScanContext";

const AssociateScanChartView = () => {
    const { viewModel, dispatch } = useContext(AssociateScanContext);

    const handleAssociateChange = (selectedAssociates) => {
        dispatch({
            type: "SET_SELECTED_ASSOCIATES",
            data: { selectedAssociates },
        });
    };

    const handleGranularityChange = (granularity) => {
        dispatch({
            type: "SET_GRANULARITY",
            data: { granularity },
        });
    };

    return (
        <React.Fragment>
            <Row widths={["grid-3", "grid-9"]} spacingInset="medium large">
                <div>
                    <Column spacingInset="none none medium">
                        <h3>Associates</h3>
                        <div style={{
                            overflow: "auto",
                            maxHeight: viewModel.associateList.length > 4 ? "125px" : "auto"
                        }}>
                            {viewModel.associateList.length > 0 && (
                                <ControlGroup
                                    name="associates"
                                    onChange={handleAssociateChange}
                                    value={viewModel.chartData.selectedAssociates}
                                >
                                    {viewModel.associateList.map((associate) => (
                                        <Checkbox key={associate.key} value={associate.key}>
                                            {associate.name}
                                        </Checkbox>
                                    ))}
                                </ControlGroup>
                            )}
                        </div>
                    </Column>

                    <Column spacingInset="medium none none">
                        <h3>Time Granularity</h3>
                        <ControlGroup
                            name="granularity"
                            onChange={handleGranularityChange}
                            value={viewModel.chartData.granularity}
                        >
                            <RadioButton value="15m">15 Minutes</RadioButton>
                            <RadioButton value="30m">30 Minutes</RadioButton>
                            <RadioButton value="1h">1 Hour</RadioButton>
                            <RadioButton value="cumulative">Cumulative</RadioButton>
                        </ControlGroup>
                    </Column>
                </div>

                <div style={{ height: "354px", position: "relative" }}>
                    <AssociateScanChart/>
                </div>
            </Row>
        </React.Fragment>
    );
};

export default AssociateScanChartView;


// WEBPACK FOOTER //
// ./src/components/associate/AssociateScanChartView.js